import { Icon } from "@msuite/ui/icons";
import { cn } from "@msuite/ui/utils";
import { getArticleProductTypeNumberString } from "@msuite/utils/stock";

/** Props Interface */
interface ArticleProductTypeTableHeaderProps {
	articleGroupNumber: number;
	articleProductTypeNumber: number;
	articleProductTypeName: string;
}

export function ArticleProductTypeTableHeader({
	articleGroupNumber,
	articleProductTypeNumber,
	articleProductTypeName,
}: ArticleProductTypeTableHeaderProps) {
	return (
		<div className={cn("flex flex-row *:tabular-nums items-center gap-2")}>
			<p>{getArticleProductTypeNumberString(articleGroupNumber, articleProductTypeNumber)}</p>
			<Icon
				name="ChevronRight"
				size={8}
			/>
			<p>{articleProductTypeName}</p>
		</div>
	);
}
